import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './PackageCard.css';
import {formatNumber} from '../../library/numberFunction';
import {mail, bubble} from '../../assets/symbols/symbols/Symbols.css';

interface PackageCardProps {
    packageData: {
        id: number;
        name: string;
        price: number;
        emailMessages: number;
        smsMessages: number;
    };
    onClick: () => void;
    isSelected: boolean;
}

function PackageCard({packageData, onClick, isSelected}: PackageCardProps) {
    const {t} = useTranslation('mailing');

    return (
        <css.packageCard 
            className={isSelected ? 'selected' : ''}
            onClick={onClick}
        >
            <css.packageCardTitle>
                <css.packageName className={isSelected ? 'selected' : ''}>{packageData.name}</css.packageName>
                <css.packagePrice>{formatNumber(packageData.price)}₪</css.packagePrice>
            </css.packageCardTitle>
            <css.detailItem $icon={mail}>
                {formatNumber(packageData.emailMessages)} {t('emails')}
            </css.detailItem>
            <css.detailItem $icon={bubble}>
                {formatNumber(packageData.smsMessages)} {t('sms')}
            </css.detailItem>
        </css.packageCard>
    );
}

export default PackageCard;
